import ApplicationController from '../../support/application_controller'

export default class extends ApplicationController {

  static targets = [
    'banner',
    'editButton'
  ]

  static classes = [
    'hide'
  ]

  bannerTargetConnected() {
    this.#toggleEditButton()
  }

  bannerTargetDisconnected() {
    this.#toggleEditButton()
  }

  connect() {
    this.#toggleEditButton()
  }

  // ==== Private

  get #hideEditButton() {
    return this.hasBannerTarget && this.bannerTarget.dataset.status === 'status_filled'
  }

  #toggleEditButton() {
    if (this.hasEditButtonTarget) {
      this.editButtonTargets.forEach((target) => {
        target.classList.toggle(this.hideClass, this.#hideEditButton)
      })
    }
  }

}
